import { createSlice } from "@reduxjs/toolkit";
import baseURL from "../../utils/config";

const filesSlice = createSlice({
  name: "files",
  initialState: {
    files: {},
    loading: false,
    uploading: false,
    error: null,
  },
  reducers: {
    fetchFilesRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchFilesSuccess: (state, action) => {
      const { threadId, files } = action.payload;
      state.loading = false;
      state.files[threadId] = files;
      state.error = null;
    },
    fetchFilesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    uploadFileRequest: (state) => {
      state.uploading = true;
      state.error = null;
    },
    uploadFileSuccess: (state, action) => {
      const { threadId, file } = action.payload;
      state.uploading = false;
      if (!state.files[threadId]) {
        state.files[threadId] = [];
      }
      state.files[threadId].push(file);
      state.error = null;
    },
    uploadFileFailure: (state, action) => {
      state.uploading = false;
      state.error = action.payload;
    },
    clearFiles: (state, action) => {
      const threadId = action.payload;
      if (threadId) {
        delete state.files[threadId];
      } else {
        state.files = {};
      }
    },
  },
});

// Helper functions for file URLs
export const getFileUrl = (fileId) => `${baseURL}/api/files/${fileId}`;
export const getFileDownloadUrl = (fileId) => `${baseURL}/api/files/${fileId}?download=true`;

export const {
  fetchFilesRequest,
  fetchFilesSuccess,
  fetchFilesFailure,
  uploadFileRequest,
  uploadFileSuccess,
  uploadFileFailure,
  clearFiles,
} = filesSlice.actions;

export default filesSlice.reducer;

